export const PARAMETER_TYPE = {
    MODULE: 'MODULE',
    CATEGORICAL: 'CATEGORICAL',
    INT: 'INT',
    DOUBLE: 'DOUBLE',
    BOOL: 'BOOL'
}
